export default {
    company_agency: "Magasin",
    my_score: "Voir le BitCORs",
    no_company_agency_found: "Aucun magasin trouvé",
    "points,": "BitCOR",
    price: "BitCOR",
    project_name: "Academia Coral",
    score: "BitCOR"
}